import { Card, CardContainer, Colors, getSpacing, Text } from '@rahtab/ui';
import React from 'react';
import { StyleSheet } from 'react-native';
import AlertIcon from '@rahtab/ui/dist/icons/AlertIcon';

interface ErrorCardProps {
  title: string;
  message: string;
}

const ErrorCard: React.VFC<ErrorCardProps> = (props) => {
  const { message, title } = props;

  return (
    <Card style={styles.card}>
      <CardContainer>
        <Text style={styles.justifiedText} variant="cardTitle" color="secondary">
          <AlertIcon fill={Colors.secondary} style={styles.cardIcon} /> {'  '}
          {title}
        </Text>
        <Text style={styles.justifiedText} margin="none">
          {message}
        </Text>
      </CardContainer>
    </Card>
  );
};

export default ErrorCard;

const styles = StyleSheet.create({
  card: {
    margin: getSpacing(),
    marginBottom: 0,
  },
  justifiedText: {
    textAlign: 'justify',
  },
  cardIcon: {
    marginTop: getSpacing(),
  },
});
